import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from './baseurl.service';
import {Observable} from 'rxjs';
import {PassModel} from '../model/PassModel';

@Injectable({
  providedIn: 'root'
})
export class PassService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getPasswords(): Observable<Record<string, PassModel[]>> {
    return this.http.get<Record<string, PassModel[]>>(`${this.baseurlService.getBaseUrl()}/passwords`);
  }

  createPassword(passModel: PassModel): Observable<PassModel> {
    return this.http.post<PassModel>(`${this.baseurlService.getBaseUrl()}/passwords`, passModel);
  }

  updatePassword(passModel: PassModel): Observable<PassModel> {
    return this.http.put<PassModel>(`${this.baseurlService.getBaseUrl()}/passwords/${passModel.id}`, passModel);
  }
}
